<app-popup-panel
  [isOpen]="true"
  size="small"
  color="mint"
  variant="secondary"
  (closed)="closed.emit()">

  <ng-container slot="header">{{ title() }}</ng-container>

  <div class="activity-card__rows">
    @for (field of fields(); track field.label) {
      <div class="activity-card__row">
        <span class="activity-card__label">{{ field.label }}</span>
        <span class="activity-card__value">{{ field.value }}</span>
      </div>
    }
  </div>

  <ng-container slot="footer">
    <app-button
      [label]="'PLANNING.SEE_MORE' | translate"
      variant="primary"
      color="mint"
      size="medium"
      [fullWidth]="true"
      (clicked)="seeMore.emit()"
      data-attr="area-planning-card-see-more">
    </app-button>
  </ng-container>

</app-popup-panel>
